/**
 * Media Browser / File Manager.
 * Main application initialization entry point.
 */

'use strict';

var app = require('mag-app');


app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language}, function () {
        app.storage = {
            favoritesStorage: [],
            network: {
                smb: [],
                nfs: []
            }
        };

        app.environment = {
            get UPnPMode () {
                return core.plugins.upnp.getState();
            },
            get readOnlyMode () {
                return core.plugins.fs.getReadOnlyState();
            }
        };

        app.runtime = {
            isModalShown:             false,
            isSearched:               false,
            stillWaitNetworkResponse: false,
            openShareAttempts:        0,
            currentServer:            '',
            currentShare:             ''
        };

        app.pages = {
            main:    require('./pages/main'),
            connect: require('./pages/connect')
        };

        app.route(app.pages.main);
        app.ready();
    });
});
